import { Modal, Tabs, Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

const GeneralModal = ({
  title,
  onChange,
  onOk,
  onCancel,
  okText,
  cancelText,
  okButtonProps,
  cancelButtonProps,
  confirmLoading,
  width = 700,
  items,
  open,
  deleteEvent,
  wEventclicked,
  htmlType,
  modalminheight,
  noFooter
}) => {
  const { t } = useTranslation("dashboard");

  return (
    <Modal
      centered
      width={width}
      // Desktop only; phones get a full-screen sheet from design-system/responsive.css.
      styles={{ body: { minHeight: modalminheight || "35vh" } }}
      destroyOnClose
      title={title}
      onOk={() => onOk?.()}
      open={open}
      onCancel={onCancel}
      footer={
        <>
          {noFooter !== "Nofooter" && (
            <Button key="Cancel" onClick={onCancel} {...cancelButtonProps}>
              {cancelText ?? t("Cancel")}
            </Button>
          )}
          {wEventclicked === "updateordelete" && (
            <Button key="Delete" type="primary" onClick={deleteEvent} danger>
              {t("Delete Event")}
            </Button>
          )}
          {noFooter !== "Nofooter" && (
            <Button
              key="submit"
              type="primary"
              htmlType={htmlType ? htmlType : ""}
              loading={confirmLoading ?? okButtonProps?.loading}
              disabled={okButtonProps?.disabled}
              onClick={() => onOk?.()}
            >
              {okText ?? t("Submit")}
            </Button>
          )}
        </>
      }
    >
      <>
        {items?.length > 0 ? (
          <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        ) : (
          items
        )}
      </>
    </Modal>
  );
};

export default GeneralModal;
